import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'FeatherOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-feather-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 20l8 -8"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 5v5h5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M9 11v4h4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 13v5h5"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 13l3.502 -3.502m2.023 -2.023l2.475 -2.475"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 18l3.499 -3.499m2.008 -2.008l2.493 -2.493"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};